export const CP_575 = 'CP_575';
export const LTR_147C = 'LTR_147C';
export const SS4 = 'SS4';
export const W2 = 'W2';
export const FORM_1040 = 'FORM_1040';

// bank statement subclasses
export const WELLS_FARGO = 'WELLS_FARGO';
export const BANK_OF_AMERICA = 'BANK_OF_AMERICA';
export const CHASE_BANK = 'CHASE_BANK';
export const PNC_BANK = 'PNC_BANK';
export const NAVY_CREDIT_UNION = 'NAVY_CREDIT_UNION';
export const CHIME = 'CHIME';
export const US_BANK = 'US_BANK';

// Payslip subtypes: Match backend constants.
export const AUTOMATIC_DATA_PROCESSING = 'AUTOMATIC_DATA_PROCESSING';
